<template>
  <div>
    <div id="CSSCanvas"></div>
    <div id="WebGLCanvas"></div>

    <!-- <div id="video_container"> -->

      <div :key="reRenderLocal">
        <div
          v-for="(track, t_index) in roomConnection.localParticipant.videoTracks"
          :key="track.key"
        >
            <ThreeDimensionalVideotrack
              :participantkey="'you'"
              :publication="track"
              :trackindex="t_index"
              :scene="webGLScene"
              :scene2="cssScene"
              :camera="camera"
              :geolocation="geolocation"
            />

        </div>
      </div>

      <!-- Remote Video Tracks -->
      <div :key="reRenderRoom">
      <!-- <div :key="reRender"> -->
        <div
          v-for="(participant, p_index) in roomConnection.participants"
          :key="participant.key"
        >
          <div
            v-for="(track, t_index) in participant[1].videoTracks"
            :key="track.key"
          >
          <!-- <div id="rotatingVideo"> -->
            <ThreeDimensionalVideotrack
              v-if="track[1].isSubscribed"
              :participantkey="participant[1].identity"
              :publication="track"
              :trackindex="calculateRemoteIndex(p_index, t_index)"
              :scene="webGLScene"
              :scene2="cssScene"
              :camera="camera"
            />
              <!-- :geolocation="geolocation" -->
          <!-- </div> -->
          </div>
        </div>          
      </div>


      <!-- Local Audio Tracks -->
      <div :key="reRenderLocalAudio">
        <div
          v-for="track in roomConnection.localParticipant.audioTracks"
          :key="track.key"
        >
          <Audiotrack :participantkey="'you'" :publication="track" />
        </div>
      </div>

      <!-- Remote Audio Tracks -->
      <div :key="reRenderRemoteAudio">
        <div
          v-for="participant in roomConnection.participants"
          :key="participant.key"
        >
          <div v-for="track in participant[1].audioTracks" :key="track.key">
            <Audiotrack
              v-if="track[1].isSubscribed"
              :participantkey="participant[1].identity"
              :publication="track"
            />
          </div>
        </div>
      </div>

    <!-- </div>       -->

  </div>
</template>

<script>
import Audiotrack from '../Audiotrack'
import ThreeDimensionalVideotrack from './ThreeDimensionalVideotrack'
import * as THREE from 'three'
import { CSS3DRenderer, CSS3DObject } from 'three/examples/jsm/renderers/CSS3DRenderer'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'

import Twilio, {
  connect,
  createLocalTracks,
  createLocalVideoTrack,
  createLocalAudioTrack,
} from "twilio-video"


export default {

  name:"FinalSphere", 
  props:["roomConnection","reRenderRoom","cameraOptions","geolocation","reRenderRemoteAudio"],

  components: {
    Audiotrack,
    ThreeDimensionalVideotrack,
  },

  data:function(){
    const webGLScene = new THREE.Scene();
    const cssScene = new THREE.Scene();

    const camera = new THREE.PerspectiveCamera(75,window.innerWidth/window.innerHeight, 0.1,2000);

    let id = 0; // Ik weet niet of dit nodig is, kom hier later op teruggaan

    const cssRenderer = new CSS3DRenderer();
    const webGLRenderer = new THREE.WebGLRenderer({alpha:true,antialias:true});

    const controls = new OrbitControls(camera, webGLRenderer.domElement);

    const geometry = new THREE.SphereBufferGeometry(2, 30, 30); // the sphere buffer
    const geometryWireFrame = new THREE.SphereBufferGeometry(2.1, 60, 60); // wireframe around the sphereVideoTrack

    // hier wil ik een verbinding maken met de API
    const BaseTexture = new THREE.TextureLoader().load('https://api.enter.hetnieuweinstituut.nl/uploads/TEXTURE_diffuse_Original_5afb72209e.jpg');
    const NormalMap = new THREE.TextureLoader().load('https://api.enter.hetnieuweinstituut.nl/uploads/TEXTURE_normal_7622287254.jpg');
    const HeightMap = new THREE.TextureLoader().load('https://api.enter.hetnieuweinstituut.nl/uploads/ball_texture_434d1e834c.jpeg');

    const material = new THREE.MeshStandardMaterial({ 
      map: BaseTexture,
      normalMap: NormalMap,
      displacementMap: HeightMap,
      displacementScale: .1,
      side:THREE.DoubleSide,
  });

    const materialforWireFrame = new THREE.MeshStandardMaterial({ 
    wireframe: true, opacity: .5,
    color: 0x70ffd4,
    normalMap: NormalMap,
    displacementMap: HeightMap,
    displacementScale: .1,
  });

    const color = 0xFFFFFF;
    const intensity = 1;
    const light = new THREE.AmbientLight(color, intensity);

    const cube = new THREE.Mesh( geometry, material );
    const cube2 = new THREE.Mesh( geometryWireFrame, materialforWireFrame );

    const line = new THREE.LineSegments(
      new THREE.WireframeGeometry(geometry),
      new THREE.LineBasicMaterial({
        color: 0xffffff,
        linewidth: 1,
        opacity: 0.5,
        transparent: true
      })
    );

    return{
      // THREEJS Attributes:
      webGLScene:webGLScene,
      cssScene: cssScene,
      camera:camera,
      controls:controls,
      cssRenderer: cssRenderer,
      webGLRenderer: webGLRenderer,
      light:light,
      cube:cube,
      cube2:cube2,
      line:line,

      //other data
      localCamera:null,
      cameraButtonDisabled: false,
      localIndex: 0,
      reRenderLocal:0,
      isCameraOn: false,
      cameraMessage:"Turn on camera",
      reRender:0,
      id:id,
      reRenderRemote:0,

      reRenderLocalAudio:0,
      // reRenderRemoteAudio:0,

    }
  },

  created: function() {
    this.webGLScene.add(this.camera);
    this.webGLScene.add(this.light);
    this.webGLScene.add(this.cube);
    this.webGLScene.add(this.line);


    this.webGLRenderer.setSize(window.innerWidth, window.innerHeight);
    this.webGLRenderer.setClearColor(0x000000,0);
    this.webGLRenderer.setPixelRatio(window.devicePixelRatio);
    this.webGLRenderer.shadowMap.enabled = true;
    this.webGLRenderer.shadowMap.type = THREE.PCFSoftShadowMap;


    this.camera.position.set( 0,4,4 );
    this.controls.update();

    this.cssRenderer.setSize(window.innerWidth, window.innerHeight);
    this.cssRenderer.domElement.style.position ='absolute';
    this.cssRenderer.domElement.style.top = '0';

  },

  mounted: function(){
    const CSSCanvas = document.getElementById("CSSCanvas");
    
    CSSCanvas.style.position = 'absolute';
    CSSCanvas.style.top = '0';
    CSSCanvas.appendChild(this.cssRenderer.domElement);


    const WebGLCanvas = document.getElementById("WebGLCanvas");
    WebGLCanvas.appendChild(this.webGLRenderer.domElement);
    this.animate();

    console.log(this.roomConnection.participants);


  },

  beforeDestroy: function(){
    // turn off camera when leaving the room ;)
    if(this.localCamera != null){
     this.turnOffCamera();
     this.turnOffMic();
    }
  },

  methods:{

    animate:function() {
      this.cssScene.children.forEach(el=>{
        el.rotation.x = this.camera.rotation.x;
        el.rotation.y = this.camera.rotation.y;
        el.rotation.z = this.camera.rotation.z;
      })
      this.webGLScene.children.forEach(el=>{
        if(el.name =="backpane"){
          el.rotation.x = this.camera.rotation.x;
          el.rotation.y = this.camera.rotation.y;
          el.rotation.z = this.camera.rotation.z;
        }
      })

      this.webGLRenderer.render(this.webGLScene,this.camera);
      this.cssRenderer.render(this.cssScene,this.camera);
      this.controls.update();
      requestAnimationFrame(this.animate);
    },

    turnOnCamera(){      
      console.log(this.roomConnection)
      const VueThis = this;
      if (VueThis.localCamera == null) {
          VueThis.cameraButtonDisabled = true;
          
          createLocalTracks({ audio: false, video: { deviceId: VueThis.cameraOptions[0].deviceId } }).then((track) => {
            
              VueThis.localIndex += 1;

              // track[0].geolocation = this.geolocation
              VueThis.roomConnection.localParticipant.publishTrack(track[0]);
              VueThis.localCamera = track[0];
              setTimeout(function () {
                  VueThis.reRenderLocal += 1;
                  // VueThis.reRenderLocal = Math.random();

                  VueThis.reRender += 1;
                  VueThis.cameraMessage = "Turn off camera";
                  VueThis.isCameraOn  = true;
                  VueThis.cameraButtonDisabled = false;
              }, 1000);
              
          });


          // this.turnOnMic();
          
          
      } else {
          this.turnOffCamera();
          // this.turnOffMic();
      }      

    },



    turnOffCamera(){
      const VueThis = this;
      VueThis.cameraMessage = "Turn on camera";
      VueThis.localCamera.stop();
      VueThis.roomConnection.localParticipant.unpublishTrack(VueThis.localCamera);
      VueThis.localCamera = null;
      VueThis.reRenderLocal += 1;
      VueThis.isCameraOn = false;
      // VueThis.reRender += 1;
      // VueThis.reRenderRoom += 1;

      this.turnOffMic();

      this.animate();

    },

    turnOnMic(){
    const VueThis = this;
    

      if (VueThis.localMic == null) {
        createLocalAudioTrack().then((track) => {
          VueThis.roomConnection.localParticipant.publishTrack(track);
          VueThis.localMic = track;
          setTimeout(function () {
            VueThis.micMessage = "Turn off microphone";
            VueThis.isMicOn = true;
            VueThis.reRenderLocalAudio += 1;
          }, 1000);
        });
      } else {
        this.turnOffMic();
      }         

    },

    turnOffMic(){
      const VueThis = this;
      VueThis.micMessage = "Turn on microphone";
      VueThis.roomConnection.localParticipant.unpublishTrack(VueThis.localMic);
      VueThis.localMic = null;
      VueThis.isMicOn = false;
      VueThis.reRenderLocalAudio += 1;
            

    },

    

    calculateRemoteIndex(p_index, t_index) {
     return p_index + t_index + 2;
    },



  },

  watch: {

    reRenderRoom: function(){
      console.log('rerenderroom')
    },

    reRender: function(){
      console.log('rerender')
    },

    reRenderRemoteAudio: function(){
      console.log('rerender audo')
    }






  }





}
</script>

<style>

</style>